export enum EStaticPageStatus {
  ENABLED = 'Activo',
  DISABLED = 'Inactivo',
}

export enum ESectionType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum EStaticPageType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum EStaticPageViewType {
  TEXT = '1',
  IMAGE = '2',
  LINK = '3',
}
